import { createContext, useContext } from 'react'

import type { Temporal } from '@js-temporal/polyfill'

import type { TimezonedNowInfo } from './hooks/useTimezonedNow'
import type { AddItemProps, CalendarItem, RenderItemFunction } from './types'

export type CalendarContextType = {
  renderItem: RenderItemFunction
  items: CalendarItem[] | undefined
  itemsByHour: Map<number, CalendarItem[]> | undefined
  itemsByDay: Map<number, CalendarItem[]> | undefined
  addItemProps: AddItemProps
  readOnly: boolean
  selectedDate: Temporal.ZonedDateTime
  is24HourFormat: boolean
  timezone: string
  currentTime: TimezonedNowInfo
  isMobile: boolean
  isCompact?: boolean
  loading: boolean
  /**
   * True while the account preferences that shape the grid chrome (week start
   * day, 12/24-hour clock) are unknown. The week and three-day grids hold back
   * until this is false so their first paint is already labeled and scrolled
   * to the current hour.
   */
  preferencesLoading: boolean
  scrollTarget?: Temporal.ZonedDateTime
}

export const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined,
)

export const useCalendarContext = (): CalendarContextType => {
  const context = useContext(CalendarContext)
  if (!context) {
    throw new Error('useCalendarContext must be used within a CalendarProvider')
  }
  return context
}
